import { render, staticRenderFns } from "./planTech.vue?vue&type=template&id=56ff4b30&scoped=true"
import script from "./planTech.vue?vue&type=script&lang=js"
export * from "./planTech.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff4b30",
  null
  
)

export default component.exports